module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"check_out":"詳細をみる","title_first":"従業員がキャリアについて","title_second":"自由に本音で語れる匿名コミュニティ"},"en":{"check_out":"check out","title_first":"A community where employees can","title_second":"freely talk about their careers anonymously"}}')
  delete Component.options._Ctor
}
